export default __webpack_public_path__ + "static/media/type_11_7.80d29dd1.svg";